export default __webpack_public_path__ + "static/media/main_section18.bce71e09.jpg";